/* eslint-disable import/prefer-default-export */
export const getHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
});
